module.exports = {
	"version": "n/a",
	"created": 1519241692061
};


//////////////////
// WEBPACK FOOTER
// ./version.json
// module id = 2893
// module chunks = 0